import {
  FETCH_TUTOR_SUBSCRIBE_RATE_SENT,
  FETCH_TUTOR_SUBSCRIBE_RATE_SUCCEEDED,
  FETCH_TUTOR_SUBSCRIBE_RATE_FAILED,
} from '../../actions/tutorData';

const initialState = {
  loading: false,
  loaded: false,
  subscribeRate: 0,
  numOfLessons: 0,
  numOfSubscribers: 0,
  periodStart: null,
  periodEnd: null,
};

export default function tutorSubscribeRateReducer(
  state = initialState,
  action,
) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_TUTOR_SUBSCRIBE_RATE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        loaded: true,
        subscribeRate: payload.unique_subscribe_rate,
        numOfLessons: payload.num_of_lessons,
        numOfSubscribers: payload.num_of_uniq_subscribers,
        periodStart: payload.period_start,
        periodEnd: payload.period_end,
      };
    case FETCH_TUTOR_SUBSCRIBE_RATE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_TUTOR_SUBSCRIBE_RATE_SENT:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
